module.exports = __webpack_public_path__ + "img/online-consultation-qrcode.9850b093.png";